/* Marketing and intake only. Existing artwork/customizer/cart code is unchanged. */
(function () {
  'use strict';
  document.querySelectorAll('[data-production-menu]').forEach(function (menu) {
    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      menu.open = false;
      menu.querySelector('summary').focus();
    });
    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target)) menu.open = false;
    });
    menu.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
    });
  });
  var intake = document.querySelector('[data-production-intake]');
  if (intake) {
    var selector = intake.querySelector('[data-intake-type]');
    var groups = intake.querySelectorAll('[data-intake-group]');
    var intent = new URLSearchParams(window.location.search).get('intent');
    if (selector) {
      if (intent === 'pod') selector.value = 'POD fulfillment partnership';
      if (intent === 'custom') selector.value = 'Custom apparel order';
      function syncGroups() {
        groups.forEach(function (group) {
          var isPartner = selector.value === 'POD fulfillment partnership';
          var isCustom = selector.value === 'Custom apparel order' || selector.value === 'Sample request';
          var show = group.dataset.intakeGroup === 'pod' ? isPartner : isCustom;
          group.hidden = !show;
          group.querySelectorAll('input, select').forEach(function (field) { field.disabled = !show; });
        });
      }
      selector.addEventListener('change', syncGroups);
      syncGroups();
    }
  }
  // Keep the existing menu behavior; add keyboard state and focus restoration.
  var menuOpen = document.querySelector('[data-menu-open]');
  var menuClose = document.querySelector('[data-menu-close]');
  var drawer = document.querySelector('[data-menu-drawer]');
  if (menuOpen && menuClose && drawer) {
    menuOpen.setAttribute('aria-expanded', 'false');
    var syncMenu = function () {
      var open = drawer.classList.contains('is-open');
      menuOpen.setAttribute('aria-expanded', String(open));
      drawer.inert = !open;
    };
    syncMenu();
    new MutationObserver(syncMenu).observe(drawer, {attributes: true, attributeFilter: ['class']});
    menuOpen.addEventListener('click', function () { drawer.inert = false; menuClose.focus(); });
    menuClose.addEventListener('click', function () { menuOpen.focus(); });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') menuOpen.focus();
      if (event.key !== 'Tab') return;
      var links = Array.from(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(function (el) { return el.getClientRects().length; });
      if (!links.length) return;
      if (event.shiftKey && document.activeElement === links[0]) { event.preventDefault(); links[links.length - 1].focus(); }
      if (!event.shiftKey && document.activeElement === links[links.length - 1]) { event.preventDefault(); links[0].focus(); }
    });
  }
})();
